import { Helmet } from 'react-helmet-async';
import { BlogLayout } from '../components/BlogLayout';
import { PageHeader } from '../components/PageHeader';

const contactEmail = 'hello@questflow.net';
const heroImage = 'https://pub-17b41bfc91754e909a0062f5845603e7.r2.dev/contact.jpeg';

export default function ContactPage() {
  return (
    <BlogLayout>
      <Helmet>
        <title>Contact - QuestFlow</title>
        <meta name="description" content="Get in touch with the QuestFlow team" />
      </Helmet>
      <div className="page-body contact-page">
        <PageHeader title="Let's talk" eyebrow="Contact" />
        <p className="contact-lead">
          Story tips, partnership ideas, feedback on the product - we read every note and usually respond within one
          business day.
        </p>

        <section className="contact-hero">
          <div className="contact-visual">
            <img
              src={heroImage}
              alt="Questflow team spaces"
              style={{ objectFit: 'cover', width: '100%', height: '100%' }}
            />
          </div>

          <div className="card contact-hero-card">
            <div className="tag-pill">Chicago roots, global hours</div>
            <h2>Tell us what you need</h2>
            <a href={`mailto:${contactEmail}`} className="contact-email contact-email-main">
              {contactEmail}
            </a>
            <p className="contact-lead">
              Send us the story, partnership idea, or product feedback you have in mind. Include links, context, and the
              outcome you want - we&apos;ll route it to the right editor or partner lead.
            </p>
            <div className="contact-meta contact-meta-rows">
              <div className="contact-meta-row">
                <span className="contact-meta-label">Response window</span>
                <span className="contact-meta-value">Under 24 hours on weekdays</span>
              </div>
              <div className="contact-meta-row">
                <span className="contact-meta-label">Best for</span>
                <span className="contact-meta-value">Press, pitches, partnerships, product input</span>
              </div>
              <div className="contact-meta-row">
                <span className="contact-meta-label">What to include</span>
                <span className="contact-meta-value">Links, deadlines, and any must-have details</span>
              </div>
            </div>
            <ul className="contact-list contact-list-tight">
              <li>Press &amp; media kits</li>
              <li>Story tips and expert quotes</li>
              <li>Product or data partnerships</li>
              <li>Newsletter swaps and collabs</li>
            </ul>
          </div>
        </section>
      </div>
    </BlogLayout>
  );
}
